import { INotificationFilter } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { create as createStore } from 'zustand';

import { sdk } from '@/services';

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 30;
const NOTIFICATION_POLLING_INTERVAL = 60000;

const NotificationService = sdk.getService('NotificationService');

interface IStore {
  page: number;
  limit: number;
  filters?: INotificationFilter;
  setFilters: (filters: INotificationFilter) => void;
  setPageAndLimit: (page: number, limit: number) => void;
}

const store = createStore<IStore>(set => ({
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
  setFilters: filters => set(state => ({ ...state, filters })),
  setPageAndLimit: (page: number, limit: number) => set(state => ({ ...state, page, limit }))
}));

export const useNotificationsList = () => {
  const [search, setSearch] = useState('');
  const { page, limit, filters, setFilters, setPageAndLimit } = store();
  const queryKey = ['notifications', `page-${page}`, `limit-${limit}`, search, filters];
  const { isLoading, data, error } = useQuery({
    queryKey,
    queryFn: () => NotificationService.getNotifications(search, { page, limit }, filters),
    refetchInterval: NOTIFICATION_POLLING_INTERVAL
  });

  const pagination = data && {
    page: data.page,
    limit: data.limit,
    hasNextPage: data.hasNextPage,
    hasPrevPage: data.hasPrevPage,
    nextPage: data.nextPage,
    pagingCounter: data.pagingCounter,
    prevPage: data.prevPage,
    totalDocs: data.totalDocs,
    totalPages: data.totalPages
  };

  return {
    notifications: data?.docs,
    isLoading,
    error,
    setPageAndLimit,
    pagination,
    setSearch,
    filters,
    setFilters
  };
};
